import PropTypes from "prop-types";

const AdditionalFormFields = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  error: PropTypes.any,
  control: PropTypes.any,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onInputChange: PropTypes.func,
  showError: PropTypes.bool,
  isRequired: PropTypes.bool,
};

export const formFieldCommonType = {
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  description: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  onChange: PropTypes.func,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.arrayOf(PropTypes.bool),
  ]),
  disabled: PropTypes.bool,
  validationSchema: PropTypes.any,
  fieldOf: PropTypes.string,
  required: PropTypes.bool,
  optional: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  fieldSize: PropTypes.oneOf(["small", "medium", "large"]),
  fieldType: PropTypes.oneOf([
    "TextInput",
    "CheckBox",
    "Switch",
    "Select",
    "NestedForm",
    "Array",
    "Radio",
    "TextArea",
    "MutliSelect",
  ]),
  InputProps: PropTypes.object,
  fields: PropTypes.arrayOf(PropTypes.object),
};

export default AdditionalFormFields;
